import React, { useState, createContext, useContext, ReactNode } from 'react';
interface CartContextType {
  isCartOpen: boolean;
  setCartOpen: (open: boolean) => void;
}
const CartContext = createContext<CartContextType | undefined>(undefined);
export function CartProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isCartOpen, setCartOpen] = useState(false);
  return <CartContext.Provider value={{
    isCartOpen,
    setCartOpen
  }} data-id="element-460">
      {children}
    </CartContext.Provider>;
}
export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}